import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { ControllerSymbolLpAction } from './controllerSymbolLp.action';
import { symbolLpFilterInitialState } from './controllerSymbolLp.constant';

export const controllerSymbolLpReducer = reducerWithInitialState(symbolLpFilterInitialState)
  .case(ControllerSymbolLpAction.destroy, () => ({
    ...symbolLpFilterInitialState,
  }));
